import React from "react";
import { array, string } from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import { SectionHeading } from "../../atoms/SectionHeading";
import "./sponsors-section.m.css";

const SponsorImage = ({ sponsor, size = "small" }) => {
  const { imageS3Key, imageMetadata, name, logoUrl } = sponsor;
  const defaultWidth = size === "large" ? 200 : 120;
  const widths = size === "large" ? [150, 200, 300] : [80, 120, 160];

  if (imageS3Key) {
    return (
      <ResponsiveImage
        slug={imageS3Key}
        metadata={imageMetadata}
        aspectRatio={null}
        defaultWidth={defaultWidth}
        widths={widths}
        imgParams={{ auto: ["format", "compress"] }}
        alt={name || "Sponsor"}
      />
    );
  }
  return logoUrl ? <img alt={name || "Sponsor"} src={logoUrl} /> : null;
};

export const SponsorsSection = ({ title, principalSponsors = [], otherSponsors = [] }) => {
  return (
    <div styleName="sponsors-section" data-section="sponsors">
      <div styleName="section-heading">
        <SectionHeading>{title}</SectionHeading>
      </div>
      {principalSponsors.length > 0 && (
        <div styleName="principal-sponsors">
          {principalSponsors.map((sponsor, index) => (
            <div key={index} styleName="principal-sponsor">
              <div styleName="sponsor-type" dangerouslySetInnerHTML={{ __html: sponsor.caption }}></div>
              <div styleName="sponsor-logo">
                <SponsorImage sponsor={sponsor} size="large" />
              </div>
            </div>
          ))}
        </div>
      )}
      {otherSponsors.length > 0 && (
        <>
          <div styleName="other-sponsors-row">
            {otherSponsors.map((sponsor, index) => (
              <div key={index} styleName="sponsor-item">
                <div styleName="sponsor-type-small" dangerouslySetInnerHTML={{ __html: sponsor.caption }}></div>
                <div styleName="sponsor-logo-small">
                  <SponsorImage sponsor={sponsor} size="small" />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

SponsorsSection.propTypes = {
  title: string.isRequired,
  principalSponsors: array,
  otherSponsors: array,
};

